import {configureStore} from "@reduxjs/toolkit";
import budgetsReducer from "./slices/budgetsSlice";
import budgetCategoriesReducer from "./slices/budgetCategoriesSlice";
import accountsReducer from "./slices/accountsSlice";
import transactionsReducer from "./slices/transactionsSlice";
import categoriesReducer from "./slices/categoriesSlice";
import rulesReducer from "./slices/rulesSlice";
import tagsReducer from "./slices/tagsSlice";
import portfolioReducer from "./slices/portfolioSlice";
import carsReducer from "./slices/carsSlice";
import loansReducer from "./slices/loansSlice";
import quotesReducer from "./slices/quotesSlice";
import mileageLogsReducer from "./slices/mileageLogsSlice";
import settingsReducer from "./slices/settingsSlice";
import appReducer from "./slices/appSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    budgets: budgetsReducer,
    budgetCategories: budgetCategoriesReducer,
    accounts: accountsReducer,
    transactions: transactionsReducer,
    cars: carsReducer,
    loans: loansReducer,
    quotes: quotesReducer,
    mileageLogs: mileageLogsReducer,
    categories: categoriesReducer,
    portfolio: portfolioReducer,
    rules: rulesReducer,
    tags: tagsReducer,
    settings: settingsReducer
  },
  devTools: process.env.NODE_ENV !== "production"
});
